import type { EntityFrontmatter } from "./entityFrontmatter";
import type { DatabaseEntrySummary } from "./outlineEntityTypes";
import type { StoryboardMapLocationChip } from "./storyboardMapLocations";
import { entityEffectiveColor } from "./entityColors";
import { displayFileName } from "./fileNames";
import { isJust, type Maybe } from "./maybe";

export function setEntitySceneLink(
  fields: EntityFrontmatter,
  file: string,
  linked: boolean,
): EntityFrontmatter {
  const sceneLinks = fields.sceneLinks.filter((link) => link.file !== file);
  return {
    ...fields,
    excludeFromScene: linked
      ? fields.excludeFromScene.filter((scene) => scene !== file)
      : isJust(fields.type) && fields.type.value === "character"
        ? [...new Set([...fields.excludeFromScene, file])]
        : fields.excludeFromScene,
    sceneLinks: linked ? [...sceneLinks, { file }] : sceneLinks,
  };
}

export function timelineEntityChips(
  scene: string,
  entries: DatabaseEntrySummary[],
  places: StoryboardMapLocationChip[],
): {
  id: string;
  kind: "entity";
  label: string;
  entryFile: string;
  color: Maybe<string>;
  manuallyLinked: boolean;
  mapLinked: boolean;
}[] {
  return entries.flatMap((entry) => {
    if (
      entry.isMap ||
      (isJust(entry.fields.type) && entry.fields.type.value === "character")
    )
      return [];
    const manuallyLinked = entry.fields.sceneLinks.some(
      (link) => link.file === scene,
    );
    const mapLinked =
      isJust(entry.fields.type) &&
      entry.fields.type.value === "location" &&
      places.some(
        (place) =>
          isJust(place.entityFile) && place.entityFile.value === entry.name,
      );
    if (manuallyLinked === false && mapLinked === false) return [];
    return [
      {
        id: `entity:${entry.name}`,
        kind: "entity" as const,
        label: displayFileName(entry.name),
        entryFile: entry.name,
        color: entityEffectiveColor(entry.fields.color, entry.fields.type),
        manuallyLinked,
        mapLinked,
      },
    ];
  });
}
